import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { ErrorFallback, GlobalContext } from 'smart-react';
/**
 * Users main screen
 * @type {React.FC<Props>}
 * @returns {React.ReactElement} The Users component.
 */
const AddUser = () => {
  const { dimensions, deviceInfo } = React.useContext(GlobalContext);
  React.useEffect(() => {}, [dimensions, deviceInfo]);
  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onReset={() => {
        // reset the state of your app so the error doesn't happen again
      }}
    >
      Add User
    </ErrorBoundary>
  );
};
export default AddUser;
